/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-extra-parens */
import React from 'react';
import ngDeps from '../../common/utilities/ngDependencies';
import { withScreenSize } from '../common/utilities/withScreenSize.jsx';

interface LoadingMarkupProps {
    isDesktop: boolean;
}

export const PollenLoadingUI = withScreenSize(({ isDesktop }: LoadingMarkupProps) => {
    return (
        <div className='life_landing-lazy-loading-ui' >
            <div className='life-landing__ad__wrapper'>
                <div className='life_landing_ad_container'>
                    {
                        !isDesktop
                            ? <div className='life_banner_ad'></div>
                            : null
                    }
                </div>
            </div>
            <div className='life-page-content-lazy-loading-ui'>
                <div className='life-tab-wrapper'>
                    <div className='life-tab-lazy-loading-ui'>
                        <section className='life-page-header-wrapper'>
                            <div className='life-page-header'>
                                <div className='life-pollen-tab-header-name-lazy-loading-ui'>Allergies & Pollen</div>
                                <h1 className='life-pollen-section-title'>{`Pollen Forecast for ${(ngDeps as any)?.user?.ActiveLocation?.Locality?.DisplayCompositeName ?? ''}`}</h1>
                            </div>
                        </section>
                        <section className='life-pollen-content-view'>
                            <div className='life-pollen-content-wrapper'>
                                <div className='life-pollen-ad-desktop-ad-section'>
                                    <div style={{ width: 300, height: 600 }}></div>
                                </div>
                                <div className='life-pollen-info-section-wrapper'>
                                    <div className='life-pollen-info-section'>
                                        <div className='life-pollen-count-wrapper'>
                                            <div className='life-pollen-count'></div>
                                        </div>
                                        <div className='life-pollen-forecast-wrapper'>
                                            <div className='life-pollen-forecast'>
                                                <div className='life-pollen-forecast-item'>
                                                    <div className='life-pollen-forecast-item-title'>Today</div>
                                                </div>
                                                <div className='life-pollen-forecast-item'>
                                                    <div className='life-pollen-forecast-item-title'>Outlook</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='life-pollen-stories-wrapper'>
                                            <div className='life-pollen-stories'>
                                                <a href='/news/' className='life-pollen-large-top-story-section-wrapper'>
                                                    <div className='life-pollen-large-top-story-section'>
                                                        <div className='life-pollen-large-top-story-title'>Allergy Season Preparedness Tips</div>
                                                        <div className='life-pollen-large-top-story-body'></div>
                                                    </div>
                                                </a>
                                                <div className='display-on-desktop-tablet life-pollen-small-story-cards-section-wrapper'>
                                                    <div className='life-pollen-small-story-card-section'>
                                                        {
                                                            Array.from(Array(4).keys()).map((index) => {
                                                                return <a key={`${index}_desktop_tablet_views`} href='/news/' aria-label='View all Top Weather stories and Weather News' className='life-pollen-small-story-card'></a>;
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className='display-on-mobile life-pollen-small-story-cards-section-wrapper'>
                                                    <div className='life-pollen-small-story-card-section'>
                                                        {
                                                            Array.from(Array(5).keys()).map((index) => {
                                                                return index === 2 
                                                                    ?   <div key={index} className='life-pollen-story-section-mobile-ad'>
                                                                        <div style={{ width: 300, height: 250 }}></div>
                                                                    </div>
                                                                    : <a key={`${index}_mobile_view`} href='/news/' aria-label='View all Top Weather stories and Weather News' className='life-pollen-small-story-card'></a>;
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
});
